module.exports = __webpack_public_path__ + "static/cloud-99e709cd49d8074aca7751aea9e9feec.mp4";